(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chak-shipping-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chak-shipping-strip')) {
    customElements.define('chak-shipping-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpicy-home"] && !Shopify.designMode) return;
  try {
    
function initXpicyCarousels(root=document){
root.querySelectorAll('[data-xpicy-carousel]').forEach(carousel=>{
if(carousel.dataset.bound)return;carousel.dataset.bound='true';
const track=carousel.querySelector('.xpicy-track');
const move=d=>track.scrollBy({left:d*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
carousel.querySelector('[data-xpicy-prev]').addEventListener('click',()=>move(-1));
carousel.querySelector('[data-xpicy-next]').addEventListener('click',()=>move(1));
const refresh=()=>{const max=track.scrollWidth-track.clientWidth;const i=max>0?Math.round(track.scrollLeft/max*2):0;carousel.querySelectorAll('.xpicy-dots i').forEach((dot,n)=>dot.classList.toggle('active',n===i));};
track.addEventListener('scroll',refresh,{passive:true});refresh();
});
}
initXpicyCarousels();
document.addEventListener('shopify:section:load',e=>initXpicyCarousels(e.target));

function initXpicyBenefits(root=document){
root.querySelectorAll('[data-xpicy-benefits]').forEach(band=>{
if(band.dataset.bound)return;band.dataset.bound='true';
const button=band.querySelector('.xpicy-benefits-toggle');
button.addEventListener('click',()=>{
const paused=band.classList.toggle('is-paused');
button.setAttribute('aria-pressed',String(paused));
button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
button.firstElementChild.textContent=paused?'▶':'Ⅱ';
});
});
}
initXpicyBenefits();
document.addEventListener('shopify:section:load',event=>initXpicyBenefits(event.target));


function initXpicyReviewColors(root=document){
root.querySelectorAll('.xpicy-reviews').forEach(container=>{
if(container.dataset.colorsBound)return;container.dataset.colorsBound='true';
let pending=false;
const styleReviews=()=>{
pending=false;
container.querySelectorAll('.shopify-app-block, .shopify-app-block *').forEach(element=>{
if(!(element instanceof HTMLElement))return;
if(['SCRIPT','STYLE','IFRAME','IMG'].includes(element.tagName))return;
const styles=getComputedStyle(element);
const bg=styles.backgroundColor.match(/[\d.]+/g);
if(bg&&bg.length>=3&&Number(bg[0])>225&&Number(bg[1])>225&&Number(bg[2])>225&&(bg.length<4||Number(bg[3])>.5)){
element.style.setProperty('background-color','transparent','important');
element.style.setProperty('box-shadow','none','important');
}
const color=styles.color.match(/[\d.]+/g);
if(color&&color.length>=3&&Number(color[0])<120&&Number(color[1])<120&&Number(color[2])<120){
element.style.setProperty('color','#faf9f6','important');
}
});
};
const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(styleReviews)}};
styleReviews();
new MutationObserver(schedule).observe(container,{childList:true,subtree:true});
});
}
initXpicyReviewColors();
document.addEventListener('shopify:section:load',event=>initXpicyReviewColors(event.target));


  } catch(e) { console.error(e); }
})();
})();
